<div class="spinner-gform-row mb-3-backdrop loader-fadeout">
    <div class="spinner-gform-row mb-3"></div>
</div>

<div [innerHTML]="dynamicHtml"></div>

<div class="col-12" *ngIf="loading" style="opacity:.9; padding: 12px;">
  <span>Aguarde, verificando login…</span>
  <!-- se você já tiver um componente de spinner, pode usar aqui -->
  <app-spinner></app-spinner>
</div>

<div class="form-row mb-3">
    <div class="col-12" *ngIf="entidade && !loading">
        <!-- <li><b>Para realizar o login clique aqui</b> <a  (click)="login()"><i class="mdi mdi-open-in-new ml-1"></i></a></li> -->
        <b>{{entidade.descricao}}</b><br/>
        <b>{{entidade.complemento}}</b>
        <br/><br/>
        <a  (click)="redirectAppCliente()">Clique aqui para acessar o sistema<i class="mdi mdi-open-in-new ml-1"></i></a>
    </div>
    <div class="col-12" *ngIf="!entidade && !loading">
        <a  (click)="login()">Clique aqui para realizar o login<i class="mdi mdi-open-in-new ml-1"></i></a>
    </div>    
</div>